import { Checkbox } from '@/components/ui/checkbox';
import { FilterPermanentLink } from '@/features/fanfiction-filters/components/FilterPermanentLink';
import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';

interface CheckboxItemProps {
  item: FilterItem;
  icon?: string;
  onClick?: () => void;
  onPermalinkNavigate?: (event: { preventDefault: () => void }) => void;
}

const NAME_CLASSNAME = 'text-[12px] text-[var(--light-text-black)] truncate';

export const CheckboxItem = ({ item, icon, onClick, onPermalinkNavigate }: CheckboxItemProps) => (
  <div className="flex justify-start items-center gap-1 cursor-pointer" onClick={onClick}>
    <div className="flex items-center gap-2 min-w-0">
      <Checkbox checked={item.checked} className="border-none bg-white" />
      <div className="flex flex-col min-w-0">
        {item.permanentUrl ? (
          <FilterPermanentLink
            href={item.permanentUrl}
            title={item.name}
            onNavigate={onPermalinkNavigate}
            className={NAME_CLASSNAME}
          >
            {icon}
            {item.name}
          </FilterPermanentLink>
        ) : (
          <span className={NAME_CLASSNAME} title={item.name}>
            {icon} {item.name}
          </span>
        )}
        {item.fandomTitle && (
          <span className="text-[10px] text-[#8B8E99] truncate" title={item.fandomTitle}>
            ({item.fandomTitle})
          </span>
        )}
      </div>
    </div>
    <div className="min-w-4 px-1 py-0.5 bg-white rounded flex justify-center items-center flex-shrink-0">
      <span className="text-xs font-medium text-[#575E74]">{item.count.toLocaleString()}</span>
    </div>
  </div>
);
